import {useState} from "react"

// import { MDB_TYPES } from "@meddbriefer/scenario-data/constants"
import { useCheckList } from "./CheckListContext"

const AddOption = ({index, phase, subPhase=null, parentID, childType}) => {
    const [newID, setNewID] = useState("")
    const [newLabel, setNewLabel] = useState("")
    const {uniqueIDs, uniqueLabels, insertRec} = useCheckList()

    const changeHandler = (event) => {
        const name = event.target.name
        const val = event.target.value
        switch (name) {
            case "newID":
                setNewID(val)
                break
            case "newLabel":
                setNewLabel(val)
                break
            default:
                console.log("unknown field name", name)
        }
    }

    const addHandler = (event) => {
        event.preventDefault()
        console.log(uniqueLabels)
        if ("" === newID) {
            console.log("Please enter an ID")
            return
        }
        if ("" === newLabel) {
            console.log("Please enter a label")
            return
        }
        if (uniqueIDs.includes(newID)) {
            console.log("id must be unique")
            return
        }
        if (uniqueLabels.includes(newLabel)) {
            console.log("label must be unique")
            return
        }
        const newRec = {
            id: newID,
            type: childType,
            label: newLabel,
            phase: phase,
            subPhase: subPhase,
            parentID: parentID
        }
        // console.log("adding", newRec, index)
        insertRec(newRec, index)
        setNewID("")
        setNewLabel("")
    }

    return (
        <div className="add-item">
            Add new option:
            <b> ID: </b> <input type="text" name="newID" value={newID} onChange={changeHandler} />
            <b> Label: </b><input type="text"  name="newLabel" value={newLabel} onChange={changeHandler} />
            <button className="add-btn" onClick={addHandler}>+</button>
        </div>
    )
}

export default AddOption